// @flow

import {Component} from 'react';

export default class SettingsComponent extends Component {}




// WEBPACK FOOTER //
// ./src/lib/settings-component.js